import * as React from 'react'
export const SvgRefineOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M15.268 11a2 2 0 013.464 0H21v2h-2.268a2 2 0 01-3.464 0H3v-2h12.268zM8 4a2 2 0 011.732 1H21v2H9.732a2 2 0 01-3.464 0H3V5h3.268A2 2 0 018 4zm1.268 13a2 2 0 013.464 0H21v2h-8.268a2 2 0 01-3.464 0H3v-2h6.268z" />
  </svg>
)
export default SvgRefineOutline
